import { useMediaQuery } from "@/hooks/use-media-query";

/**
 * A phone held sideways: landscape and too short for the portrait stack (cover, tabs, sheet)
 * to leave any room for content. Height is the scarce axis there, so the in-game layout turns
 * 90°: side dock, header band, two content columns. Mirrors the `ls:` variant in index.css —
 * keep the two in step.
 *
 * Through the shared external-store `useMediaQuery`, so the dock, the shell and the container
 * all read the SAME snapshot in the same render: with a private state + effect per consumer, a
 * rotation while open could commit one of them a render behind the others (the bottom sheet still
 * mounted next to the side dock's reserved room).
 */
export const LANDSCAPE_PHONE_QUERY =
  "(orientation: landscape) and (max-height: 500px)";

export const useIsLandscapePhone = (): boolean =>
  useMediaQuery(LANDSCAPE_PHONE_QUERY);
